import { apiSlice } from "../../../api/ApiService";
import { getHeadersFromRedux } from "../../../utility/functions/common-functions";
import { DragDropCardList } from "../../../utility/interfaces/carePlanInterfaces";

interface DragDropResponse {
  appModules: DragDropCardList[];
}

const useDragDropListApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDragDropList: builder.query<
      DragDropResponse,
      { patientId: number; preferredLanguage: string }
    >({
      query: (patient) => {
        const headers = getHeadersFromRedux();
        headers["X-Language"] = patient.preferredLanguage;
        return {
          url: `/api/v1/PatientPreference/${patient.patientId}/dashboard-preference`,
          method: "GET",
          headers,
        };
      },
      providesTags: (result, error, { patientId }) => [
        { type: "DashboardPreference", id: patientId },
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useGetDragDropListQuery } = useDragDropListApi;
export default useDragDropListApi;
